<template>
  <page-base :modules="modules" :type="type" />
</template>

<script>
export default {
  data () {
    return {
      type: 'preview',
      modules: []
    }
  },
  created () {
    let query = this.$route.query
    this.previewCode = query.previewCode
    this.getPreview()
  },
  methods: {
    getPreview () {
      this.$http.request(this.$http.pathMap.wxPreview + this.previewCode, 'get').then(res => {
        let config = JSON.parse(res.data)
        console.log(config)
        let { fontColor, modules } = config
        document.body.style.setProperty('--theme-font-color', fontColor)
        this.modules = modules
      })
    }
  },

}
</script>
